let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Znfo")).then(() => parcelRequire('88aCw'));